import { render, staticRenderFns } from "./CatalogFilterMobile.vue?vue&type=template&id=3b156535&scoped=true&"
import script from "./CatalogFilterMobile.vue?vue&type=script&lang=js&"
export * from "./CatalogFilterMobile.vue?vue&type=script&lang=js&"
import style0 from "./CatalogFilterMobile.vue?vue&type=style&index=0&id=3b156535&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b156535",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F03-organisms%2Fcatalog-filter-mobile%2FCatalogFilterMobile.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports